import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import { AccountStorage } from "@services/account";
var accountStorage = new AccountStorage();
export default {
  data: function data() {
    return {
      searchVal: "",
      list: [],
      total: 0,
      current: 1,
      // 页码
      perPage: 10,
      rangeBefore: 3,
      rangeAfter: 2,
      companyId: ""
    };
  },
  created: function created() {
    var loginCompanyId = accountStorage.getCacheUserInfo();
    this.companyId = loginCompanyId.loginCompanyId;
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.list = [];
              url = "/pjyy-deepexi-user-center/api/v1/companyDebts/summary/pageList?companyId=".concat(_this.companyId, "&page=").concat(_this.current, "&pageSize=").concat(_this.perPage);
              _context.next = 4;
              return _this.$getHttpClient().get(url);
            case 4:
              result = _context.sent;
              _this.list = result.data.data.list;
              _this.total = result.data.data.total;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onSearch: function onSearch() {
      this.current = 1;
      this.getList();
    },
    handleChange: function handleChange(val) {
      this.current = val;
      this.getList();
    },
    goDetail: function goDetail(v) {
      window.sessionStorage.setItem("totalAmountOwe", JSON.stringify(v));
      this.$router.push({
        name: "debtMessageDetail",
        params: {
          id: v.id
        }
      });
    }
  }
};